import React from "react";

const HistoryBadges = ({ entries, badgeStyle }) => (
  <span
    className="summary-value"
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
      justifyContent: "flex-end",
    }}
  >
    {entries
      .map((entry) => entry?.value)
      .filter(Boolean)
      .map((value, idx) => (
        <span
          key={`${value}-${idx}`}
          style={{
            padding: "3px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: "600",
            whiteSpace: "nowrap",
            ...badgeStyle,
          }}
        >
          {value}
        </span>
      ))}
  </span>
);

export const RegistrationDetailsSummarySection = ({
  formData,
  conferenceName,
  currentHost,
  effectiveCategoriesHistory,
  effectiveRegistrationTypesHistory,
  registrationBaseUrl,
}) => {
  const openStudentIdCard = (event) => {
    event.preventDefault();
    let fileUrl;

    if (
      formData.regId &&
      (formData.studentIdCardUploaded ||
        formData.studentIdCard === "DATABASE" ||
        !formData.studentIdCard.startsWith("data:"))
    ) {
      fileUrl = `${registrationBaseUrl}/registration/${formData.regId}/file/id-card`;
      console.log("Opening student ID from database:", fileUrl);
    } else if (
      formData.studentIdCard &&
      formData.studentIdCard.startsWith("data:")
    ) {
      fileUrl = formData.studentIdCard;
      console.log("Opening student ID base64 preview");
    } else if (
      formData.studentIdCard &&
      formData.studentIdCard.startsWith("http")
    ) {
      fileUrl = formData.studentIdCard;
      console.log("Opening student ID legacy URL:", fileUrl);
    } else if (formData.studentIdCard) {
      const path = formData.studentIdCard.startsWith("/")
        ? formData.studentIdCard
        : `/${formData.studentIdCard}`;
      fileUrl = `${registrationBaseUrl}${path}`;
      console.log("Opening student ID legacy path:", fileUrl);
    }

    if (fileUrl) {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } else {
      console.error("No student ID file URL available");
      alert("Unable to open document. Please try uploading again.");
    }
  };

  const isStudent =
    (formData.category && formData.category.toLowerCase().includes("student")) ||
    (formData.registrationType &&
      formData.registrationType.toLowerCase().includes("student"));

  return (
    <div className="summary-section">
      <h4>Registration Details</h4>

      {formData.department && (
        <div className="summary-row">
          <span className="summary-label">Department:</span>
          <span className="summary-value">
            {formData.department === "Others"
              ? formData.otherDepartment
              : formData.department}
          </span>
        </div>
      )}
      {formData.category && (
        <div className="summary-row">
          <span className="summary-label">Category:</span>
          <span className="summary-value">{formData.category}</span>
        </div>
      )}
      {formData.paid === true && effectiveCategoriesHistory.length > 1 && (
        <div className="summary-row">
          <span className="summary-label">All Categories:</span>
          <HistoryBadges
            entries={effectiveCategoriesHistory}
            badgeStyle={{
              backgroundColor: "#e8f1ff",
              color: "#0b63c7",
            }}
          />
        </div>
      )}
      {formData.category === "ISCCM(Members)" &&
        formData.membershipNumber && (
          <div className="summary-row">
            <span className="summary-label">Membership Number:</span>
            <span className="summary-value">{formData.membershipNumber}</span>
          </div>
        )}
      {formData.category &&
        formData.category.toString().toLowerCase().includes("isa") &&
        !formData.category.toString().toLowerCase().includes("isccm") &&
        formData.isaMembershipNumber && (
          <div className="summary-row">
            <span className="summary-label">ISA Membership Number:</span>
            <span className="summary-value">
              {formData.isaMembershipNumber}
            </span>
          </div>
        )}
      {isStudent &&
        (formData.studentIdCard || formData.studentIdCardUploaded) && (
          <div className="summary-row">
            <span className="summary-label">Student ID Card:</span>
            <span className="summary-value">
              <a
                href="#"
                onClick={openStudentIdCard}
                style={{
                  color: "#0066cc",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                View Uploaded Document
              </a>
            </span>
          </div>
        )}
      {formData.registrationType &&
        formData.registrationType.trim() !== "" &&
        formData.registrationType !== "TBD" && (
          <div className="summary-row">
            <span className="summary-label">Registration Type:</span>
            <span className="summary-value">{formData.registrationType}</span>
          </div>
        )}
      {formData.paid === true &&
        effectiveRegistrationTypesHistory.length > 1 && (
          <div className="summary-row">
            <span className="summary-label">All Registration Types:</span>
            <HistoryBadges
              entries={effectiveRegistrationTypesHistory}
              badgeStyle={{
                backgroundColor: "#e9f8ef",
                color: "#137a3d",
              }}
            />
          </div>
        )}
      <div className="summary-row">
        <span className="summary-label">Conference:</span>
        <span className="summary-value">
          {formData.conference || conferenceName || currentHost}
        </span>
      </div>
    </div>
  );
};
